import script from "./CurtainAnimation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurtainAnimation.vue?vue&type=script&setup=true&lang=ts"

import "./CurtainAnimation.vue?vue&type=style&index=0&id=c1401ff4&lang=css"

const __exports__ = script;

export default __exports__